import { MainLayoutSidebarComponent } from './main-layout-sidebar.component';

export function getNavRoutes(component: MainLayoutSidebarComponent) {
  return [
    {
      link: '/dashboard',
      active: false,
      name: 'Inicio',
      icon: 'inicio.svg',
      exact: true,
      subNav: null,
      click: 'selectedOption/Inicio',
      if: true,
      view: false,
    },
    {
      link: null,
      active: false,
      name: 'Módulo de investigación',
      icon: 'modulo_investigacion.svg',
      exact: false,
      if: component.hasUnits,
      subNav: component.userUnits,
      click: 'selectedOption/Módulo de investigación',
    },
    {
      link: `/withoutAssigned/${component.anaUnit}`,
      active: false,
      name: 'Análisis',
      icon: 'modulo_investigacion.svg',
      exact: true,
      click: 'selectedOption/Análisis',
      if: component.seeAna,
    },
    {
      link: null,
      active: false,
      name: 'Administración',
      icon: 'administracion.svg',
      if:
        component.seeUsers ||
        component.seeRoles ||
        component.seeUnits ||
        component.seeLogSistemControl ||
        component.seeLogCases ||
        component.seeMainReports ||
        component.seeStatusConection,
      exact: false,
      subNav: [
        {
          link: '/users',
          name: 'Gestión de usuarios',
          exact: true,
          active: false,
          click: 'selectedOption/Gestión de usuarios',
          if: component.seeUsers,
        },
        {
          link: '/roles',
          name: 'Gestión de roles y permisos',
          exact: true,
          active: false,
          click: 'selectedOption/Gestión de roles y permisos',
          if: component.seeRoles,
        },

        {
          link: '/gestion-apis',
          name: 'Gestión de APIS',
          exact: true,
          active: false,
          click: 'selectedOption/Gestión de APIS',
          if: component.seeRoles,
        },
        {
          link: '/ai-settings',
          name: 'Configuración IA',
          exact: true,
          active: false,
          click: 'selectedOption/Configuración IA',
          if: component.seeRoles,
        },
        {
          link: '/dashboard/seguridad-y-auditoria/auditoria',
          name: 'Auditoría',
          exact: true,
          active: false,
          click: 'selectedOption/Auditoría',
          if: false,
        },
        {
          link: '/units',
          name: 'Unidades',
          exact: true,
          active: false,
          click: 'selectedOption/Unidades',
          if: component.seeUnits,
        },
        // {
        //   link: '/auditoria-casos',
        //   name: 'Log control del sistema',
        //   exact: true,
        //   active: false,
        //   click: 'selectedOption/Log control del sistema',
        //   if: component.seeLogSistemControl,
        // },
        {
          link: '/log-casos',
          name: 'Log casos',
          exact: true,
          active: false,
          click: 'selectedOption/Log casos',
          if: component.seeLogCases,
        },
        {
          link: 'informe-productividad',
          name: 'Informe productividad',
          exact: true,
          active: false,
          click: 'selectedOption/Informe productividad',
          if: component.seeMainReports,
        },
        {
          link: 'usuarios-conectados',
          name: 'Usuarios conectados al Sistema',
          exact: true,
          active: false,
          click: 'selectedOption/Usuarios conectados al Sistema',
          if: component.seeStatusConection,
        },
      ],
      view: false,
      click: 'selectedOption/Administración',
    },
    {
      link: '/auditoria-casos',
      name: 'Log control del sistema',
      exact: true,
      active: false,
      icon: 'seeLogSistemControl.svg',
      click: 'selectedOption/Log control del sistema',
      if: component.seeLogSistemControl,
    },
    {
      link: '/timer',
      name: 'Gestión de Temporizador',
      exact: true,
      active: false,
      icon: 'temporizador_side.svg',
      click: 'selectedOption/Gestión de Temporizador',
      if: component.seeTimer,
    },
    // La entrada vieja 'Forsker' (chatbot suelto) ya no va en el menú: el
    // asistente Forsker vive dentro del caso (SCG-364). La ruta /forsker sigue.
    {
      link: '/licencias',
      active: false,
      name: 'Licencias',
      icon: 'info-solid1.svg',
      exact: true,
      click: 'selectedOption/Licencias',
      if: component.seeLicenses,
    },
    {
      link: null,
      active: false,
      name: 'Acerca De',
      icon: 'info-solid1.svg',
      exact: true,
      subNav: null,
      click: 'selectedOption/Acerca De',
      if: true,
      view: false,
    },
  ];
}
